import apiService from './ApiService';

class TipoAsistenteService {
  async getTipos() {
    const response = await apiService.get('/tipoasistentes');
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos cargar los tipos de asistente.';
      throw new Error(msg);
    }
    const list = response?.tipos || response?.Tipos || response?.data || response || [];
    return Array.isArray(list) ? list : [];
  }

  async getTiposActivos() {
    const response = await apiService.get('/tipoasistentes/activos');
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos cargar los tipos de asistente.';
      throw new Error(msg);
    }
    const list = response?.tipos || response?.Tipos || response?.data || response || [];
    return Array.isArray(list) ? list : [];
  }
}

const tipoAsistenteService = new TipoAsistenteService();

export default tipoAsistenteService;
